import { UserBonus } from 'config/types/bonus/userBonus'
import useModal from 'hooks/useModal'
import BonusService from 'services/BonusService'
import UpComingBonusModal from './UpComingBonusModal'

export const UPCOMING_BONUS_MODAL_KEY = 'upcoming-bonus'

export const useUpcomingBonusModal = () => {
  const [onPresentUpcomingBonusModal] = useModal(UpComingBonusModal, UPCOMING_BONUS_MODAL_KEY)

  const presentUpcomingBonusesModal = async (bonus: UserBonus) => {
    if (!bonus.id) {
      return
    }

    const result = await BonusService.getJourneyBonuses(bonus.id).call()
    if (result) onPresentUpcomingBonusModal({ bonusInfo: [bonus, ...result.data.items] })
  }

  return { presentUpcomingBonusesModal }
}

